import { render, staticRenderFns } from "./editBankAccount.vue?vue&type=template&id=70ef3db9&lang=pug"
import script from "./editBankAccount.vue?vue&type=script&lang=js"
export * from "./editBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports